import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card, Col, Row, Spinner, Badge, Button, Modal, ModalHeader, ModalBody, 
  Form, Label, Input, UncontrolledTooltip, CardBody
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3; // Admin yetki kontrolü

  // Yeni SQL şemasına uygun veri modeli
  const [blogData, setBlogData] = useState({
    ID: null,
    Title: "",
    Summary: "", 
    Content_Text: "", 
    Image_Url: "",
    Category: "TEKNOLOJİ",
    IsActive: true,
    Author_ID: authUser?.ID || 0
  });

  const toggleModal = () => {
    setModal(!modal);
    if(modal) {
      setBlogData({ 
        Title: "", Summary: "", Content_Text: "", Image_Url: "", 
        Category: "TEKNOLOJİ", IsActive: true, Author_ID: authUser?.ID || 0 
      });
      setImagePreview(null);
      setSelectedFile(null);
      setIsEdit(false);
    }
  };

  const fetchBlogs = async () => {
    setIsLoading(true);
    try {
      // IsActive kullanıyoruz ve endpoint Blog
      const filter = isAdmin ? "" : "$filter=IsActive eq true&";
      const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Blog?${filter}$orderby=Created_DateTime desc`);
      const result = await response.json();
      if (result && result.value) setBlogs(result.value);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchBlogs(); }, [isAdmin]);

  // --- DÜZENLEME MODUNU AÇ ---
  const handleEdit = (blog) => {
    setBlogData({
      ID: blog.ID,
      Title: blog.Title,
      Summary: blog.Summary || "",
      Content_Text: blog.Content_Text,
      Image_Url: blog.Image_Url,
      Category: blog.Category || "TEKNOLOJİ",
      IsActive: blog.IsActive,
      Author_ID: blog.Author_ID
    });
    setImagePreview(blog.Image_Url);
    setIsEdit(true);
    setModal(true);
  };

  // --- BLOG SİL (DELETE) ---
  const handleDelete = async (id) => {
    if (window.confirm("Bu blog yazısını silmek istediğinize emin misiniz?")) {
      try {
        const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Blog(${id})`, { method: "DELETE" });
        if (response.ok) {
          toast.success("Yazı başarıyla silindi.");
          fetchBlogs();
        }
      } catch (error) {
        toast.error("Silme işlemi başarısız.");
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // --- KAYDET / GÜNCELLE (POST / PUT) ---
  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      let finalImageUrl = blogData.Image_Url;

      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const uploadRes = await fetch("https://hiflowapi.stechomeyazilim.info/Uploads/uploads.php", { method: "POST", body: formData });
        const uploadResult = await uploadRes.json();
        if (uploadResult.status) finalImageUrl = uploadResult.url;
      }

      const payload = { ...blogData, Image_Url: finalImageUrl };
      const url = isEdit ? `https://hiflowapi.stechomeyazilim.info/Blog(${blogData.ID})` : "https://hiflowapi.stechomeyazilim.info/Blog";
      const method = isEdit ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        toast.success(isEdit ? "Yazı güncellendi!" : "Yeni yazı eklendi!");
        toggleModal();
        fetchBlogs();
      }
    } catch (error) {
      toast.error("İşlem başarısız.");
    } finally {
      setIsSaving(false);
    }
  };

  // Tarih formatlama fonksiyonu (Örn: 12 MART 2026)
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('tr-TR', options).toUpperCase();
  };

  return (
    <React.Fragment>
      <div className="container-fluid py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">BLOG & BİLGİ MERKEZİ</h2>
          {isAdmin && (
            <Button color="danger" className="rounded-pill px-4" onClick={toggleModal}>
              <i className="mdi mdi-plus me-1"></i> Yeni Yazı Oluştur
            </Button>
          )}
        </div>

        {isLoading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : (
          <Row>
            {blogs.map((blog) => (
              <Col md={4} key={blog.ID} className="mb-4">
                <Card className="h-100 shadow-sm border-0 rounded-4" style={{ overflow: 'hidden' }}>
                  {blog.Image_Url && (
                    <img src={blog.Image_Url} alt={blog.Title} className="card-img-top" style={{ height: "200px", objectFit: "cover" }} />
                  )}
                  <CardBody className="p-4 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <Badge color="soft-danger" className="text-danger bg-danger bg-opacity-10 px-2 py-1 rounded-1">
                          {blog.Category}
                        </Badge>
                        <small className="text-muted fw-semibold" style={{ fontSize: "12px" }}>
                          {formatDate(blog.Publish_Date || blog.Created_DateTime)}
                        </small>
                      </div>

                      {/* Admin Kontrolleri */}
                      {isAdmin && (
                        <div className="d-flex gap-1">
                          <Button color="light" size="sm" onClick={() => handleEdit(blog)} id={`edit-${blog.ID}`} className="p-1">
                            <i className="mdi mdi-pencil text-success font-size-14"></i>
                          </Button>
                          <Button color="light" size="sm" onClick={() => handleDelete(blog.ID)} id={`del-${blog.ID}`} className="p-1">
                            <i className="mdi mdi-delete text-danger font-size-14"></i>
                          </Button>
                          <UncontrolledTooltip target={`edit-${blog.ID}`}>Düzenle</UncontrolledTooltip>
                          <UncontrolledTooltip target={`del-${blog.ID}`}>Sil</UncontrolledTooltip>
                        </div>
                      )}
                    </div>

                    <h5 className="fw-bold mb-3 text-dark">{blog.Title}</h5>
                    <p className="text-muted flex-grow-1" style={{ fontSize: "14px" }}>
                      {blog.Summary || (blog.Content_Text?.substring(0, 100) + "...")}
                    </p>

                    <div className="mt-3">
                      <Link to={`/blog-details/${blog.ID}`} className="text-danger fw-bold text-decoration-none">
                        İNCELE <i className="mdi mdi-arrow-right ms-1"></i>
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>

      {/* --- EKLE / DÜZENLE MODALI --- */}
      <Modal isOpen={modal} toggle={toggleModal} centered size="lg">
        <ModalHeader toggle={toggleModal} className="bg-light">
          <h5 className="mb-0 fw-bold">{isEdit ? "Yazıyı Düzenle" : "Yeni Yazı Oluştur"}</h5>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSave}>
            <div className="mb-3">
              <Label className="fw-semibold">Başlık</Label>
              <Input required value={blogData.Title} onChange={e => setBlogData({...blogData, Title: e.target.value})} placeholder="Örn: Lojistikte Dijital Dönüşüm" />
            </div>
            
            <Row>
              <Col md={6} className="mb-3">
                <Label className="fw-semibold">Kategori</Label>
                <Input type="select" value={blogData.Category} onChange={e => setBlogData({...blogData, Category: e.target.value})}>
                  <option value="TEKNOLOJİ">TEKNOLOJİ</option>
                  <option value="GÜVENLİK">GÜVENLİK</option>
                  <option value="VERİMLİLİK">VERİMLİLİK</option>
                  <option value="LOJİSTİK">LOJİSTİK</option>
                </Input>
              </Col>
              <Col md={6} className="mb-3">
                <Label className="fw-semibold">Kapak Görseli</Label>
                <Input type="file" onChange={handleFileChange} />
              </Col>
            </Row>

            {imagePreview && (
              <div className="mb-3">
                <img src={imagePreview} alt="Preview" style={{maxHeight:"150px", borderRadius: "8px"}} className="img-thumbnail shadow-sm" />
              </div>
            )}

            <div className="mb-3">
              <Label className="fw-semibold">Kısa Özet (Kart üzerinde görünür)</Label>
              <Input type="text" maxLength={150} value={blogData.Summary} onChange={e => setBlogData({...blogData, Summary: e.target.value})} placeholder="Geleneksel süreçler yerini akıllı algoritmalara bırakıyor." />
            </div>

            <div className="mb-3">
              <Label className="fw-semibold">Detaylı İçerik</Label>
              <Input type="textarea" rows="8" value={blogData.Content_Text} onChange={e => setBlogData({...blogData, Content_Text: e.target.value})} placeholder="Yazının tamamını buraya girin..." />
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button color="light" onClick={toggleModal}>İptal</Button>
              <Button color="danger" type="submit" disabled={isSaving} className="px-4">
                {isSaving ? <Spinner size="sm" /> : (isEdit ? "Değişiklikleri Kaydet" : "Yayınla")}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <ToastContainer autoClose={2000} position="bottom-right" />
    </React.Fragment>
  );
};

export default BlogList;